import { put, takeEvery } from 'redux-saga/effects'
import { queryList, UPDATE_PAGE, resetList, UPDATE_SORT } from './actions'
import { addressReducer } from '../../utility/state'

/**
 * Trigger list reset and query implicitly.
 * @param {string} [listKey] Key of the list to address in the state
 * @param {Object} action
 */
export function* triggerListQuery(listKey, { reducer }) {
    listKey = listKey || reducer
    const resetAction = listKey ? addressReducer(listKey, resetList()) : resetList()
    yield put(resetAction)
    const queryAction = listKey ? addressReducer(listKey, queryList()) : queryList()
    yield put(queryAction)
}

/**
 * Trigger a query when page changes.
 */
function* queryPage({ reducer }) {
    // The triggered action should address the same reducer
    const queryAction = reducer ? addressReducer(reducer, queryList()) : queryList()
    yield put(queryAction)
}

/**
 * Saga for basic list functionality.
 */
export function* listSaga() {
    // Handle page updates
    yield takeEvery(UPDATE_PAGE, queryPage)
    // Trigger query on sort update
    yield takeEvery(UPDATE_SORT, triggerListQuery, null)
}
